module.exports = __webpack_public_path__ + "img/Group 663three.f9772bb4.png";